var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.formVisible
    ? _c(
        "div",
        [
          _c(
            "el-dialog",
            {
              directives: [{ name: "dragDialog", rawName: "v-dragDialog" }],
              attrs: {
                title: _vm.formTitle,
                visible: _vm.formVisible,
                width: "600px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  _vm.formVisible = $event
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { inline: true } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "选择成员:" } },
                    [
                      _c("customerSelector", {
                        ref: "customerSelector",
                        on: { change: _vm.customerChanged }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success", size: "small" },
                          on: { click: _vm.handleAdd }
                        },
                        [_vm._v("添加成员")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    size: "mini",
                    stripe: "",
                    border: "",
                    data: _vm.groupMembers,
                    "highlight-current-row": "",
                    "expand-on-click-node": "false",
                    "header-cell-style": {
                      "font-weight": "400",
                      height: "40px",
                      padding: "0",
                      background: "#4a8bc1",
                      color: "white"
                    }
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "index", width: "30" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "Member.RealName",
                      label: "成员名称",
                      "min-width": "120"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "Member.Mobile",
                      label: "联系方式",
                      "min-width": "120"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "IsManager",
                      label: "是否管理员",
                      "min-width": "120"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("el-switch", {
                                on: {
                                  change: function($event) {
                                    return _vm.handleManage(scope.row)
                                  }
                                },
                                model: {
                                  value: scope.row.IsManager,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "IsManager", $$v)
                                  },
                                  expression: "scope.row.IsManager"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1300712874
                    )
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "100", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleRemove(scope.row)
                                    }
                                  }
                                },
                                [_vm._v("移除")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1383092334
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }